export default () => ({
  /**
   * USER
   */
  userFavorites: [],
  reachableUsers: [],
  reachableRoles: [],
  lastUserInfosRefresh: null,

  /**
   * GENERAL
   */
  loading: false,

  /**
   * KNOWLEDGE
   */
  knowledges: [],
  focusKnowledge: null,
  focusKnowledgeRoots: [],

  /**
   * NAVIGATION
   */
  navigationLanguage: '',
  path: [],
  diagPath: [],
  focusNavItem: null,
  focusDiagItem: null,
  previousItems: [],

  /**
   * SEARCH
   */
  size: 10,
  query: '',
  filters: [],
  results: [],
  totalCount: 0,
  recentSearches: [],
  focusLevel: '',

  /**
   * NOTIFICATION
   */
  notifications: [],
  hasMoreNotifications: true,
  notificationsRead: [],
  urgentNotification: null,
});
